import { render } from "./ProsesGesiap.vue?vue&type=template&id=499d473f"
import script from "./ProsesGesiap.vue?vue&type=script&lang=js"
export * from "./ProsesGesiap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__